import { useEffect, useState } from "react";
import Header from "../layout/Header";
import { toast } from "react-toastify";
import { ParseErrors } from "../utils/parse-errors";
import axiosInstance from "../utils/axios-instance";
import Button from "../components/button/Button";
import Footer from "../layout/Footer";
import { useSearchParams } from "react-router-dom";

const Contact = () => {
  const [params, setParams] = useSearchParams();
  const [values, setvalues] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(false);

  const Handlesubmit = async () => {
    if (validate()) {
      setLoading(true);
      try {
        await axiosInstance.post("/contact/form", values);
        toast.success("Form submitted successfully!");
        setLoading(false);
        setvalues({});
      } catch (error) {
        console.log(error);
        toast.error(ParseErrors(error));
        setLoading(false);
      }
    }
  };

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setvalues({ ...values, [e.target.name]: e.target.value });
  };

  const validate = () => {
    if (!values?.firstName || !values?.lastName) {
      toast.error("Please enter full name");
      return false;
    } else if (!values?.email) {
      toast.error("Please enter email");
      return false;
    } else if (!values?.message) {
      toast.error("Please enter message");
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (params.has("email")) {
      const email = params.get("email");
      setvalues({ ...values, email });
      params.delete("email");
      setParams(params);
    }
  }, []);

  const inputClass = "w-full bg-white text-lightBlack border border-gray-200 rounded-xl py-3 px-4 text-[14.5px] placeholder-gray-400";
  const labelClass = "block text-lightBlack text-[13px] font-medium mb-1.5";

  return (
    <>
      <Header />
      <div className="w-full bg-white">
        <div className="w-[90%] max-w-[1100px] mx-auto py-16 lg:py-24">
          <div className="text-center mb-10">
            <span className="text-blue text-xs font-medium tracking-widest uppercase">Contact</span>
            <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-lightBlack mt-3">
              We'd love to <span className="text-blue">hear from you</span>
            </h1>
            <p className="w-full md:w-[60%] text-base text-gray-500 mx-auto mt-4 leading-relaxed">
              Whether you have a question, need support, or just want to share feedback — our team typically responds within 24 hours.
            </p>
          </div>

          <div className="bg-white border border-gray-100 rounded-3xl p-8 lg:p-10 shadow-soft">
            <div className="space-y-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="w-full">
                  <label className={labelClass}>First Name</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Your first name"
                    name="firstName"
                    value={values?.firstName || ""}
                    onChange={onChange}
                  />
                </div>
                <div className="w-full">
                  <label className={labelClass}>Last Name</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Your last name"
                    name="lastName"
                    value={values?.lastName || ""}
                    onChange={onChange}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="w-full">
                  <label className={labelClass}>Email</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="you@example.com"
                    name="email"
                    value={values?.email || ""}
                    onChange={onChange}
                  />
                </div>
                <div className="w-full">
                  <label className={labelClass}>Phone Number</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Your phone"
                    name="phone"
                    value={values?.phone || ""}
                    onChange={onChange}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="w-full">
                  <label className={labelClass}>Occupation</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="What you do"
                    name="occupation"
                    value={values?.occupation || ""}
                    onChange={onChange}
                  />
                </div>
                <div className="w-full">
                  <label className={labelClass}>Company</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Where you work"
                    name="company"
                    value={values?.company || ""}
                    onChange={onChange}
                  />
                </div>
              </div>

              <div className="w-full">
                <label className={labelClass}>Message</label>
                <textarea
                  className={`${inputClass} h-[140px] resize-none`}
                  placeholder="Tell us what's on your mind…"
                  name="message"
                  value={values?.message || ""}
                  onChange={onChange}
                />
              </div>

              <div className="flex justify-end pt-2">
                <div className="w-full md:w-auto">
                  <Button
                    onClick={Handlesubmit}
                    isLoading={loading}
                    disabled={loading}
                    className="!w-full md:!w-auto !px-10"
                  >
                    Send Message
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
